import moment from 'moment';
import React, { useEffect } from 'react'
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';

function Summary({ map, mapReturn, data, setDriversInstructions, setDriversInstructionsReturn, cn = '', showInstructions = true, rideFare, rideFareReturn, setAmount = () => { }, title = 'Booking Summary', description = '' }) {

    const convertCurrency = useCurrencyConverter();
    const { currency } = useCurrency();


    useEffect(() => {
        let onewayTotal = (data?.selectedVehicle?.basePricePKR + rideFare + (data?.selectedAddon?.reduce((sum, addon) => sum + addon.priceInPKR, 0) || 0)) || 0
        let returnTotal = (data?.selectedVehicleReturn?.basePricePKR + rideFareReturn + (data?.selectedAddonReturn?.reduce((sum, addon) => sum + addon.priceInPKR, 0) || 0)) || 0
        setAmount(onewayTotal + returnTotal)
    }, [data, rideFare, rideFareReturn])

    const handleDriversInstructions = (e) => {
        setDriversInstructions(e.target.value)
    }

    const handleReturnDriversInstructions = (e) => {
        setDriversInstructionsReturn(e.target.value)
    }
    return (
        <div>
            <div className={`text-center text-lg !text-white font-bold mt-4 ${cn}`} style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                {title}
            </div>
            {data?.isFinal &&
                <div className="font-bold text-center text-black text-xl mt-4">
                    <p className="!text-base">Your Booking Reference No is:</p>
                    <div className={`flex flex-row justify-center gap-4 text-2xl ${data?.type == 'return' ? 'mb-1' : 'mb-4'}`}>
                        <span className="font-bold">One Way:</span>
                        <span>{data?.oneWayReferenceNo}</span>
                    </div>
                    {data.type == 'return' && (
                        <div className="flex flex-row justify-center gap-4 mb-2 text-2xl">
                            <span className="font-bold">Return:</span>
                            <span>{data?.returnReferenceNo}</span>
                        </div>
                    )}
                </div>
            }


            <div className='text-center text-lg'>
                {description}
            </div>
            {data?.isFinal ? (
                <div className="text-left text-black p-4 mt-8">
                    <h2 className="font-bold !text-lg">Airport Transfer Options:</h2>
                    <ul className="list-disc pl-5">
                        <li>
                            <strong>Standard Transfer:</strong> Complimentary use of the Standard Dropoff Car Park, involving a short 2-minute walk to/from the airport terminal. Maximum stay permitted is 30 minutes.
                        </li>
                        <li>
                            <strong>Premium Transfer:</strong> For a supplementary fee payable by customer at the airport, utilize the premium car park located directly in front of the airport's departures and arrivals. Maximum stay permitted is 30 minutes.
                        </li>
                        <li>
                            <strong>Meet and Greet Service:</strong> Includes parking in the standard short-stay car park. The driver will personally greet you at the arrivals hall and escort you to the vehicle, approximately a 2-minute walk.
                        </li>
                    </ul>

                    <h2 className="font-bold !text-lg !mt-8">Complimentary Amenities:</h2>
                    <ul className="list-disc pl-5">
                        <li>
                            <strong>Mineral Water:</strong> Complimentary bottled mineral water is available upon request.
                        </li>
                        <li>
                            <strong>Hotspot Internet:</strong> Access to hotspot internet service from the driver is available if requested before the driver starts driving.
                        </li>
                    </ul>

                    <h2 className="font-bold !text-lg !mt-8">Payment Details:</h2>
                    <ul className="list-disc pl-5">
                        {
                            (() => {
                                const computedTotal = (data?.selectedVehicle?.basePricePKR || 0) + (rideFare || 0) + ((data?.selectedAddon?.reduce((sum, addon) => sum + (addon?.priceInPKR || 0), 0)) || 0);
                                const displayCurrency = data?.summaryCurrency || currency;
                                // If discountedAmount exists, it's already in the selected currency (from frontend conversion)
                                // Otherwise, convert the PKR computedTotal to selected currency
                                const amountPaid = (data?.discountedAmount !== undefined && data?.discountedAmount !== null)
                                    ? data?.discountedAmount  // Already converted, use as-is
                                    : convertCurrency(computedTotal); // Convert from PKR
                                return (
                                    <>
                                        <li><strong>Total Amount Paid:</strong> {displayCurrency} {amountPaid}</li>
                                        <li><strong>Discount Code:</strong> {data?.discountCode || '—'}</li>
                                        <li><strong>Payment Method:</strong> {data?.paymentMethod || 'Secure Checkout Card Payment'}</li>
                                    </>
                                );
                            })()
                        }
                    </ul>

                    <h2 className="font-bold !text-lg !mt-8">Important Notices:</h2>
                    <ul className="list-disc pl-5">
                        <li>A dedicated driver will be assigned to your booking 12 hours prior to your pickup time. If necessary, the driver may contact you to confirm details or provide assistance through WhatsApp message.</li>
                    </ul>

                    <h2 className="font-bold !text-lg !mt-8">Cancellation Policy:</h2>
                    <ul className="list-disc pl-5">
                        <li>
                            <strong>Flexible Cancellation:</strong> Cancellations more than 24 hours prior to pickup incur a 15% fee. Remaining amount's refund may take 7 working days.
                        </li>
                        <li>
                            <strong>Moderate Cancellation:</strong> Cancellations between 24 to 12 hours prior to pickup incur a 30% fee. Remaining amount's refund may take 7 working days.
                        </li>
                        <li>
                            <strong>Strict Cancellation:</strong> Cancellations between 12 to 6 hours prior to pickup incur a 50% fee. Remaining amount's refund may take 7 working days.
                        </li>
                        <li>
                            <strong>Last-Minute Cancellation:</strong> Cancellations less than 6 hours before pickup are non-refundable due to the disruption caused to scheduling.
                        </li>
                    </ul>

                    <h2 className="font-bold !text-lg !mt-8">No-Show Policy:</h2>
                    <ul className="list-disc pl-5">
                        <li>Failure to appear at the designated pickup location without notifying us within 30 minutes of your scheduled time will result in the driver marking the job as complete without a refund.</li>
                        <li>Additional waiting time is chargeable at PKR 500 per 30 minutes or PKR 1000 per hour if the driver is requested to wait beyond the initial 30 minutes.</li>
                    </ul>

                    <p className="mt-4">
                        Should you require any adjustments to your booking or wish to inquire further, please contact us without hesitation at
                        <a href="mailto:hello@sawaripakistan.com" className="text-blue-500"> hello@sawaripakistan.com</a> or +92 335 4400044 (available at WhatsApp).
                    </p>

                    <p className="mt-4">
                        We eagerly anticipate providing you with a seamless and comfortable transfer experience. Kindly ensure your prompt readiness at the designated pickup location at least 5 minutes prior to your departure.
                    </p>

                    <p className="mt-4">Thank you for choosing Sawari Pakistan.</p>

                    <p className="mt-4">Best regards,</p>

                    <p className="font-bold">Automated Online Booking System</p>
                    <p className="font-bold">Sawari Pakistan</p>
                </div>

            ) : (
                <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem] flex flex-col justify-evenly !mt-0 !pt-0">
                    <div>
                        <div className={`text-center text-lg !text-white font-bold mt-4 ${cn}`} style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                            One Way Journey
                        </div>
                        {map}
                        <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem]">
                            <table className="w-full">
                                <tbody>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Date / Time:</td>
                                        <td>{moment(data.date).format('MMMM Do, YYYY')} / {moment(data.time, 'HH:mm').format('hh:mm A')}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Pickup:</td>
                                        <td>{data?.pickup || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Additional Pickups:</td>
                                        <td>
                                            {data?.additionalPickups?.length > 0 && data.additionalPickups.some(p => p.pickup) ? 
                                                data.additionalPickups.filter(f => f.pickup).map((pu, index) => (
                                                    <div key={index}>{index + 1}) {pu.pickup}</div>
                                                )) 
                                                : 'N/A'
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Destination:</td>
                                        <td>{data?.destination || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Passengers:</td>
                                        <td>{data?.passengerCount || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Luggage:</td>
                                        <td>{data?.luggageCount || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Flight Number:</td>
                                        <td>{data?.flightNumber || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Kilometres:</td>
                                        <td>{data?.totalDistance || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Duration:</td>
                                        <td>{data?.totalDuration || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Vehicle:</td>
                                        <td>{data?.selectedVehicle?.name || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Addons:</td>
                                        <td>{data?.selectedAddon?.map(addon => addon.name).join(', ') || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-semibold py-2 pr-4">Price:</td>
                                        <td>{currency} {convertCurrency(data?.selectedVehicle?.basePricePKR + rideFare + (data?.selectedAddon?.reduce((sum, addon) => sum + addon.priceInPKR, 0) || 0))}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        {showInstructions && (
                            <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem] flex flex-row">
                                <div className='text-lg font-bold'>Special instructions for driver:</div>
                                <textarea
                                    onChange={handleDriversInstructions}
                                    style={{ border: '1px solid black' }}
                                    className="w-full h-full p-4 bg-white text-black resize-none focus:outline-none"
                                ></textarea>
                            </div>
                        )}
                    </div>

                    {data.type == 'return' && (
                        <div>
                            <div className={`text-center text-lg !text-white font-bold mt-4 ${cn}`} style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                Return Journey
                            </div>
                            {mapReturn}
                            <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem]">
                                <table className="w-full">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Date / Time:</td>
                                            <td>{moment(data.returnDate).format('MMMM Do, YYYY')} / {moment(data.returnTime, 'HH:mm').format('hh:mm A')}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Pickup:</td>
                                            <td>{data?.returnPickup || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Additional Pickups:</td>
                                            <td>
                                                {data?.returnAdditionalPickups?.length > 0 && data.returnAdditionalPickups.some(p => p.pickup) ? 
                                                    data.returnAdditionalPickups.filter(f => f.pickup).map((pu, index) => (
                                                        <div key={index}>{index + 1}) {pu.pickup}</div>
                                                    ))
                                                    : 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Destination:</td>
                                            <td>{data?.returnDestination || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Passengers:</td>
                                            <td>{data?.returnPassengerCount || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Luggage:</td>
                                            <td>{data?.returnLuggageCount || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Flight Number:</td>
                                            <td>{data?.returnFlightNumber || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Kilometres:</td>
                                            <td>{data?.totalDistanceReturn || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Duration:</td>
                                            <td>{data?.totalDurationReturn || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Vehicle:</td>
                                            <td>{data?.selectedVehicleReturn?.name || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Addons:</td>
                                            <td>{data?.selectedAddonReturn?.map(addon => addon.name).join(', ') || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold py-2 pr-4">Price:</td>
                                            <td>{currency} {convertCurrency(data?.selectedVehicleReturn?.basePricePKR + rideFareReturn + (data?.selectedAddonReturn?.reduce((sum, addon) => sum + addon.priceInPKR, 0) || 0))}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            {showInstructions && (
                                <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem] flex flex-row">
                                    <div className='text-lg font-bold'>Special instructions for driver:</div>
                                    <textarea
                                        onChange={handleReturnDriversInstructions}
                                        style={{ border: '1px solid black' }}
                                        className="w-full h-full p-4 bg-white text-black resize-none focus:outline-none"
                                    ></textarea>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Summary